import { useState, useEffect } from 'react'
import { pagosService, locatariosService } from '../services/api'
import { IconSearch } from '@tabler/icons-react'

export default function Pagos() {
  const [morosos, setMorosos] = useState([])
  const [pagos, setPagos] = useState([])
  const [seleccionado, setSeleccionado] = useState(null)
  const [estadoCuenta, setEstadoCuenta] = useState(null)
  const [loading, setLoading] = useState(true)
  const [mostrarAbono, setMostrarAbono] = useState(false)
  const [mostrarDeuda, setMostrarDeuda] = useState(false)
  const [mostrarBuscador, setMostrarBuscador] = useState(false)
  const [form, setForm] = useState({ monto: '', concepto: '', referencia: '' })
  const [guardando, setGuardando] = useState(false)
  const [tab, setTab] = useState('morosos')
  const [sinPermisos, setSinPermisos] = useState(false)
  const [buscarResidente, setBuscarResidente] = useState('')
  const [locatarios, setLocatarios] = useState([])
  const [residentesFiltrados, setResidentesFiltrados] = useState([])
  const [residensteSeleccionado, setResidenteSeleccionado] = useState(null)

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
  const esDirector = usuario.rol === 'director'

  useEffect(() => { cargar() }, [])
  useEffect(() => {
    locatariosService.listar({ limit: 800 }).then(r => {
      setLocatarios(r.data.data || [])
      setResidentesFiltrados(r.data.data || [])
    })
  }, [])

  useEffect(() => {
    if (seleccionado) cargarEstadoCuenta(seleccionado.locatario?.id || seleccionado.id)
  }, [seleccionado])

  useEffect(() => {
    if (!buscarResidente.trim()) {
      setResidentesFiltrados(locatarios)
    } else {
      const q = buscarResidente.toLowerCase()
      setResidentesFiltrados(locatarios.filter(l =>
        l.nombre?.toLowerCase().includes(q) ||
        l.subscriptionExternalId?.toLowerCase().includes(q) ||
        l.email?.toLowerCase().includes(q)
      ))
    }
  }, [buscarResidente, locatarios])

  const cargar = async () => {
    setLoading(true)
    try {
      const [morososRes, pagosRes] = await Promise.all([
        pagosService.morosos(),
        pagosService.listar({ limit: 50 })
      ])
      setMorosos(morososRes.data.data || [])
      setPagos(pagosRes.data.data || [])
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const cargarEstadoCuenta = async (id) => {
    try {
      const res = await pagosService.estadoCuenta(id)
      setEstadoCuenta(res.data)
    } catch { setEstadoCuenta(null) }
  }

  const mostrarSinPermisos = () => {
    setSinPermisos(true)
    setTimeout(() => setSinPermisos(false), 3000)
  }

  const registrarAbono = async () => {
    if (!form.monto || !form.concepto) return
    setGuardando(true)
    try {
      const locId = seleccionado?.locatario?.id || seleccionado?.id || residensteSeleccionado?.id
      await pagosService.registrarAbono({ locatarioId: locId, ...form })
      setMostrarAbono(false)
      setForm({ monto: '', concepto: '', referencia: '' })
      cargar()
      cargarEstadoCuenta(locId)
    } catch (err) { console.error(err) }
    finally { setGuardando(false) }
  }

  const registrarDeuda = async () => {
    if (!form.monto || !form.concepto) return
    setGuardando(true)
    try {
      const locId = seleccionado?.locatario?.id || seleccionado?.id || residensteSeleccionado?.id
      await pagosService.registrarDeuda({ locatarioId: locId, ...form })
      setMostrarDeuda(false)
      setForm({ monto: '', concepto: '', referencia: '' })
      cargar()
      cargarEstadoCuenta(locId)
    } catch (err) { console.error(err) }
    finally { setGuardando(false) }
  }

  const totalDeuda = morosos.reduce((sum, m) => sum + (m.totalDeuda || 0), 0)

  return (
    <div style={{ display: 'flex', gap: 16, height: 'calc(100vh - 120px)' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {sinPermisos && (
          <div style={{ background: '#FAECE7', border: '1px solid #F5C3B0', borderRadius: 8, padding: '10px 16px', marginBottom: 12, color: '#993C1D', fontSize: 13 }}>
            No tienes permisos para realizar esta acción. Contacta al administrador.
          </div>
        )}

        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <div className="metric" style={{ flex: 1 }}>
            <div className="metric-label">Total deuda cartera antigua</div>
            <div className="metric-value danger">${totalDeuda.toLocaleString('es-MX')}</div>
            <div className="metric-sub">{morosos.length} residentes con deuda</div>
          </div>
          <div className="metric" style={{ flex: 1 }}>
            <div className="metric-label">Pagos registrados</div>
            <div className="metric-value gold">{pagos.filter(p => p.estado === 'pagado').length}</div>
            <div className="metric-sub">abonos en cartera antigua</div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <button className={`btn ${tab === 'morosos' ? 'btn-primary' : ''}`} onClick={() => setTab('morosos')}>
            Morosos ({morosos.length})
          </button>
          <button className={`btn ${tab === 'historial' ? 'btn-primary' : ''}`} onClick={() => setTab('historial')}>
            Historial de pagos
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn" onClick={() => setMostrarBuscador(true)}>
            <IconSearch size={14} /> Buscar residente
          </button>
        </div>

        <div className="card" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: 0 }}>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {loading && <div style={{ padding: 24, textAlign: 'center', color: '#8A8A7A' }}>Cargando...</div>}
            {!loading && tab === 'morosos' && (
              <table className="table">
                <thead>
                  <tr>
                    <th>Unidad</th>
                    <th>Residente</th>
                    <th>Conceptos</th>
                    <th>Total deuda</th>
                  </tr>
                </thead>
                <tbody>
                  {morosos.map((m, i) => (
                    <tr key={i} onClick={() => setSeleccionado(m)}
                      style={{ background: seleccionado?.locatario?.id === m.locatario?.id ? '#F5EDDD' : '' }}>
                      <td style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500 }}>{m.locatario?.subscriptionExternalId}</td>
                      <td>
                        <div style={{ fontWeight: 500 }}>{m.locatario?.nombre}</div>
                        <div className="text-muted">{m.locatario?.email}</div>
                      </td>
                      <td className="text-muted">{m.numeroConceptos} concepto(s)</td>
                      <td style={{ fontWeight: 500, color: '#993C1D' }}>${m.totalDeuda?.toLocaleString('es-MX')}</td>
                    </tr>
                  ))}
                  {morosos.length === 0 && (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: '#8A8A7A', padding: 24 }}>Sin deudas registradas</td></tr>
                  )}
                </tbody>
              </table>
            )}
            {!loading && tab === 'historial' && (
              <table className="table">
                <thead>
                  <tr>
                    <th>Unidad</th>
                    <th>Concepto</th>
                    <th>Referencia</th>
                    <th>Monto</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {pagos.map(p => (
                    <tr key={p.id}>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{p.locatario?.subscriptionExternalId}</td>
                      <td>{p.concepto}</td>
                      <td className="text-muted">{p.referencia || '—'}</td>
                      <td style={{ fontWeight: 500, color: p.estado === 'pagado' ? '#3B6D11' : '#993C1D' }}>
                        ${p.monto?.toLocaleString('es-MX')}
                      </td>
                      <td><span className={`badge badge-${p.estado === 'pagado' ? 'resuelto' : 'abierto'}`}>{p.estado}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {(seleccionado || residensteSeleccionado) && (
        <div className="card" style={{ width: 280, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 16, overflowY: 'auto' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: '#FAECE7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 500, color: '#993C1D', margin: '0 auto 10px' }}>
              {(seleccionado?.locatario?.subscriptionExternalId || residensteSeleccionado?.subscriptionExternalId)?.slice(0, 2)}
            </div>
            <div style={{ fontWeight: 500 }}>{seleccionado?.locatario?.nombre || residensteSeleccionado?.nombre}</div>
            <div className="text-muted">{seleccionado?.locatario?.subscriptionExternalId || residensteSeleccionado?.subscriptionExternalId}</div>
          </div>

          {estadoCuenta && (
            <div>
              <div style={{ fontSize: 11, color: '#8A8A7A', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Resumen</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                <div style={{ background: '#FAECE7', borderRadius: 8, padding: 10 }}>
                  <div style={{ fontSize: 10, color: '#8A8A7A' }}>Deuda total</div>
                  <div style={{ fontSize: 15, fontWeight: 500, color: '#993C1D' }}>${estadoCuenta.resumen.totalPendiente?.toLocaleString('es-MX')}</div>
                </div>
                <div style={{ background: '#EAF3DE', borderRadius: 8, padding: 10 }}>
                  <div style={{ fontSize: 10, color: '#8A8A7A' }}>Abonado</div>
                  <div style={{ fontSize: 15, fontWeight: 500, color: '#3B6D11' }}>${estadoCuenta.resumen.totalAbonado?.toLocaleString('es-MX')}</div>
                </div>
              </div>
              <div style={{ fontSize: 11, color: '#8A8A7A', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Historial</div>
              {estadoCuenta.historial?.slice(0, 5).map(p => (
                <div key={p.id} style={{ fontSize: 12, padding: '5px 0', borderBottom: '1px solid #E8E0D0', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#8A8A7A' }}>{p.concepto?.slice(0, 20)}...</span>
                  <span style={{ fontWeight: 500, color: p.estado === 'pagado' ? '#3B6D11' : '#993C1D' }}>${p.monto?.toLocaleString('es-MX')}</span>
                </div>
              ))}
            </div>
          )}

          <div style={{ display: 'flex', gap: 6 }}>
            <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => {
              if (!esDirector) { mostrarSinPermisos(); return }
              setMostrarDeuda(true)
              setForm({ monto: '', concepto: '', referencia: '' })
            }}>+ Deuda</button>
            <button className="btn btn-sm btn-primary" style={{ flex: 1 }} onClick={() => {
              if (!esDirector) { mostrarSinPermisos(); return }
              setMostrarAbono(true)
              setForm({ monto: '', concepto: '', referencia: '' })
            }}>+ Abono</button>
          </div>
        </div>
      )}

      {mostrarBuscador && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div className="card" style={{ width: 480, padding: 24 }}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 16 }}>Buscar residente</div>
            <div style={{ position: 'relative', marginBottom: 8 }}>
              <IconSearch size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#8A8A7A' }} />
              <input className="form-input" style={{ paddingLeft: 30 }}
                placeholder="Nombre, unidad o correo..."
                value={buscarResidente}
                autoFocus
                onChange={e => setBuscarResidente(e.target.value)} />
            </div>
            <div style={{ border: '1px solid #D4C9B0', borderRadius: 8, maxHeight: 300, overflowY: 'auto', background: '#FDFAF4' }}>
              {residentesFiltrados.slice(0, 15).map(l => (
                <div key={l.id}
                  onClick={() => {
                    setResidenteSeleccionado(l)
                    setSeleccionado(null)
                    cargarEstadoCuenta(l.id)
                    setMostrarBuscador(false)
                    setBuscarResidente('')
                  }}
                  style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #E8E0D0', fontSize: 13 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#F5EDDD'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500 }}>{l.subscriptionExternalId}</span>
                  {' — '}<span style={{ fontWeight: 500 }}>{l.nombre}</span>
                  <div className="text-muted" style={{ marginTop: 2 }}>{l.email}</div>
                </div>
              ))}
              {residentesFiltrados.length === 0 && <div style={{ padding: '12px 14px', color: '#8A8A7A' }}>Sin resultados</div>}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
              <button className="btn" onClick={() => { setMostrarBuscador(false); setBuscarResidente('') }}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {(mostrarAbono || mostrarDeuda) && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div className="card" style={{ width: 400, padding: 24 }}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 20 }}>
              {mostrarAbono ? 'Registrar abono' : 'Registrar deuda'}
            </div>
            <div className="form-group">
              <label className="form-label">Monto (MXN)</label>
              <input className="form-input" type="number" placeholder="0.00" value={form.monto} onChange={e => setForm({ ...form, monto: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Concepto</label>
              <input className="form-input" placeholder="Ej: Renta enero 2024" value={form.concepto} onChange={e => setForm({ ...form, concepto: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Referencia (opcional)</label>
              <input className="form-input" placeholder="Número de transferencia o cheque" value={form.referencia} onChange={e => setForm({ ...form, referencia: e.target.value })} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => { setMostrarAbono(false); setMostrarDeuda(false) }}>Cancelar</button>
              <button className="btn btn-primary" onClick={mostrarAbono ? registrarAbono : registrarDeuda} disabled={guardando}>
                {guardando ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}